import "./ForStores.module.css";
import Cabecera from "@/reusable_sections/Header";
import IntroduccionParaTiendas from "./sections/IntroduccionParaTiendas";
import FormularioDeContactoB2b from "./sections/FormularioDeContactoB2b";
import PieDePagena from "@/reusable_sections/Footer";
export default function ForStoresPage() {
  return <div>
      <Cabecera />
      <IntroduccionParaTiendas />
      <FormularioDeContactoB2b />
      <PieDePagena />
    </div>;
}